
(function ($) {
 "use strict";
 	// handle JP cart
	var _href = window.location.href
	// console.log('start...');
	// console.log(_href);
	// console.log(_href.startsWith('https://jp.vtthai.com'))
	// console.log(_href.indexOf('/checkouts/'))
    if ("https://jp.vtthai.com/cart" === _href) {
    // if ("https://jp.vtthai.com/cart" === _href ||
		// (_href.startsWith('https://jp.vtthai.com' && _href.indexOf('/checkouts/') !== -1))) {
        // console.log('redirect')
        window.location.replace('https://cart6.shopserve.jp/-/vtthai.jp/cart.php')
    }

    function isJPPage() {
		return window.location.hostname.startsWith('jp');
	}

	jQuery(document).ready(function(){
		changeShopSortUrl();
		adjustHeaderBottomPadder();
		$( window ).resize(function() {
			adjustHeaderBottomPadder();
			workaroundFirefox();
		});
		adjustLangSwitcher();
        handleJPCart();
		activateFullScreenProductWhenClick();
		$( window ).resize(function() {
			if (!isPhone() && $('#product_fullscreen_image_container').is(':visible')) {
				adjustFullImageLayout();
			}
		});

	});

	function isIndexPage() {
		return $('.header-top').hasClass('index');
	}

	function handleJPCart(){
        // if ("https://jp.vtthai.com/cart" === $(location).attr('href')) {
        //     // console.log('redirect')
        //     window.location.replace('https://cart6.shopserve.jp/-/vtthai.jp/cart.php')
        // }
        // var hostname = $(location).attr('hostname');
        // if (hostname.startsWith('jp')) {
        //     // console.log('handleJPCart')
        //     // console.log(hostname)
			// // console.log($(location))
			// $('.cart-list').remove();
        // }
        if (isJPPage()) {
            $('.cart-list').remove();
        }
	}

	function activateFullScreenProductWhenClick() {
		if (isPhone()) {
			return;
		}
		$('#zoom1').click(function() {
			if(!doesDivExist('product_fullscreen_image_container')) {
				$('body').prepend('<div id="product_fullscreen_image_container"><img id="product_fullscreen_image" src="' + $('#zoom1').attr('src') + '"/><img id="product_fullscreen_close" src="//cdn.shopify.com/s/files/1/1445/8322/t/11/assets/close.png?v=140288549431677343061618796791" /></div>');
			} else {
				$('#product_fullscreen_image').attr('src',$('#zoom1').attr('src'));
				adjustFullImageLayout();
				$('#product_fullscreen_image_container').show();
			}
			disableScroll();
		});
		addClickHandlerForFullProdImgOnceDivExists();
	}

	function doesDivExist(name) {
		if($("#" + name).length == 0) {
			return false;
		} else {
			return true;
		}
	}

	function addClickHandlerForFullProdImgOnceDivExists() {
		var intervalLock = setInterval(function() {
				if (doesDivExist('product_fullscreen_image_container')) {
					$('#product_fullscreen_image_container').click(function () {
						deactivateFullScreenProductWhenClick();
					});
					adjustFullImageLayout();
					clearInterval(intervalLock);
				}
			}
			, 250);
	}

	function adjustFullImageLayout() {
		var top = $(document).scrollTop();
		$('#product_fullscreen_image_container').css('top', top);
		var winH = $( window ).height();
		var winW = $( window ).width();

		var imgT, imgL;
		var idealImgW = winW * 0.9;
		var idealImgH = winH * 0.9;

		var img = document.getElementById('product_fullscreen_image');
		var imgW = img.naturalWidth;
		var imgH = img.naturalHeight;

		var winWHRatio = winW/winH;
		var imgWHRatio = imgW/imgH;
		if (winWHRatio > imgWHRatio) {
			idealImgW = idealImgH * imgWHRatio;
		} else {
			idealImgH = idealImgW / imgWHRatio;
		}
		// readjust top & left accordingly
		imgT = (winH - idealImgH) / 2;
		imgL = (winW - idealImgW) / 2;

		var closeT = imgT - 16;
		var closeL = imgL + idealImgW - 16;
		$('#product_fullscreen_close').css('top', closeT);
		$('#product_fullscreen_close').css('left', closeL);

		$('#product_fullscreen_image').css('top', imgT);
		$('#product_fullscreen_image').css('left', imgL);
		$('#product_fullscreen_image').css('width', idealImgW);
		$('#product_fullscreen_image').css('height', idealImgH);

	}

	function deactivateFullScreenProductWhenClick() {
		// alert('deactivating');
		$("#product_fullscreen_image_container").hide();
		enableScroll();
		// $( "body" ).remove( "#product_fullscreen_image_container" );
	}

	/****** BEGIN Disable/Enable Scrolling *****/
	var keys = {37: 1, 38: 1, 39: 1, 40: 1};

	function preventDefault(e) {
		e = e || window.event;
		if (e.preventDefault)
			e.preventDefault();
		e.returnValue = false;
	}

	function preventDefaultForScrollKeys(e) {
		if (keys[e.keyCode]) {
			preventDefault(e);
			return false;
		}
	}

	function disableScroll() {
		if (window.addEventListener) // older FF
			window.addEventListener('DOMMouseScroll', preventDefault, false);
		window.onwheel = preventDefault; // modern standard
		window.onmousewheel = document.onmousewheel = preventDefault; // older browsers, IE
		window.ontouchmove  = preventDefault; // mobile
		document.onkeydown  = preventDefaultForScrollKeys;
	}

	function enableScroll() {
		if (window.removeEventListener)
			window.removeEventListener('DOMMouseScroll', preventDefault, false);
		window.onmousewheel = document.onmousewheel = null;
		window.onwheel = null;
		window.ontouchmove = null;
		document.onkeydown = null;
	}
	/****** END Disable/Enable Scrolling *****/

	function changeShopSortUrl() {
		$("a[href='/collections/all']").attr('href', '/collections/all?sort_by=best-selling')
	}

	function isPhone(){
		var userAgent = navigator.userAgent || navigator.vendor || window.opera;

		// Windows Phone must come first because its UA also contains "Android"
		if (/windows phone/i.test(userAgent)) {
			return true;
		}

		if (/android/i.test(userAgent)) {
			return true;
		}

		// iOS detection from: http://stackoverflow.com/a/9039885/177710
		if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
			return true;
		}
		return false;
	}

	function adjustHeaderBottomPadder() {
		var vdoH = 600;
		var padder = $('.header-bottom-padder.index');
		if (typeof padder !== 'undefined' && typeof padder.offset() !== 'undefined') {
			var desiredH = vdoH - padder.offset().top;
			$('.header-bottom-padder.index').height(desiredH);
		}
	}

	function workaroundFirefox() {
		var is_firefox = navigator.userAgent.indexOf('Firefox') > -1;
		if (is_firefox && !isIndexPage()) {
			//console.log($(window).width());
			if ($( window ).width() < 753) {
				$('#ly-slick-languages-switcher').css({
					'top': '-16px'
				});
				$('.mini-cart-icon').parent().css({
					'top': '-15px'
				});
			} else {
				$('#ly-slick-languages-switcher').css({
					'top': '0px'
				});
				$('.mini-cart-icon').parent().css({
					'top': '0px'
				});
			}
		}
	}
	// Workaround to set width on lang switch as it's set by langify on element style which can't be overridden by css
	function adjustLangSwitcher() {

		var is_explorer = navigator.userAgent.indexOf('MSIE') > -1;
		var is_firefox = navigator.userAgent.indexOf('Firefox') > -1;
		var is_chrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
		var is_safari = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);
		var is_opera = navigator.userAgent.toLowerCase().indexOf("op") > -1;
		var is_index_page = isIndexPage();


		var langSwitchWidth = 35;
		var numOfLang = 2;
		var resetLangSwitchWidthInterval = setInterval(function(){
			if (typeof $('.dd-pointer') === 'undefined') {
				// do nothing as we have to wait until all objects are ready
				return;
			}

			if ($('.dd-options').css('overflow') != 'hidden') {
				//console.log('isIndex2: ' + is_index_page);
				var border = '2px solid #353535';
				var containerMarginTop = '-16px';
				var containerMarginLeft = '-43px';
				if (is_index_page) {
					border = '2px solid white';
					containerMarginTop = '-15px';
					containerMarginLeft = '-23px';
					if (is_safari || is_firefox) {
						containerMarginTop = '-17px';
					}
				} else {
					if (is_safari || is_firefox) {
						containerMarginTop = '-17px';
					}
				}

				$('#ly-slick-languages-switcher').parent().css({
					'z-index': '10200000'
				});

				if (is_index_page) {
					$('#ly-slick-languages-switcher').parent().css({
						'padding-right': '12px',
					});
				}

				$('#ly-slick-languages-switcher').width(langSwitchWidth);
				$('.dd-select').width(langSwitchWidth);
				$('.dd-options').width(langSwitchWidth);
				// $('.dd-selected').css('padding-left',0);

				$('#ly-slick-languages-switcher').css({
					'margin-top': containerMarginTop,
					'margin-left': containerMarginLeft,
				});

				$('.dd-select').css({
					'height': '32px',
					'width': 'auto',
					'border-radius': '0',
					'background-color': 'none',
					'border': border,
				});

				$('.dd-selected').css({
					'padding-right': '24px',
					'padding-left': '0px',
					'display': 'inline',
				});
				$('.dd-options').css({
					'overflow': 'hidden',
					'width': langSwitchWidth + 'px',
					'height': (langSwitchWidth*numOfLang) + 'px',
					'border': border,
					'margin-top': '2px',
				});

				$('.dd-option').css({
					'padding': '0px',
					'padding-top': '0px',
					'padding-right': '28px',
					'width': '61px',
					'height': '32px',
				});

				
				$('.dd-options > li:nth-child(2)').css({
					'padding-top': '4px',
					'height': '32px',
				});


				$('.dd-pointer').hide();
				var flagW = 28;
				/*
				 $('.dd-selected-image').css({
				 'padding-left': '3px',
				 'padding-top': '5px',
				 'width': flagW + 'px',
				 });
				 */
				$('.dd-option-image').css({
					// 'padding-left': '3px',
					'padding-top': '3px,',
					// 'width': flagW + 'px',
				});
				// hide the currently selected language
				$('.dd-option-selected').parent().hide();
				workaroundFirefox();
			} else {
				clearInterval(resetLangSwitchWidthInterval);
			}
		}, 100);

	}

})(jQuery);